import React from "react";
import { cn } from "~/utils";

const InvoiceBadge = ({ isPaid }) => {
  return (
    <div
      className={cn(
        "my-auto w-[80px] rounded px-2 py-1 text-center text-xs font-semibold text-slate-700",
        isPaid ? "bg-green-100" : "bg-slate-100",
      )}
    >
      {isPaid ? "Paid" : "Generated"}
    </div>
  );
};

export default InvoiceBadge;
